import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ApiError } from 'src/config/request/fetcher/error';
import { DataHubService } from 'src/core/services/datahub';
import { TryPagePublishSchema } from 'src/core/services/datahub/schemas/content/tryPagePublishSchema';
import { PageCacheUpdater } from 'src/modules/contentList/helpers';
import { usePublishContentMutation } from 'src/modules/contents/hooks/usePublishContentMutation';
import { useGetModuleById } from 'src/modules/modules/hooks/useGetModuleById/useGetModuleById';
import { Switch } from 'src/shared/components/form/switch';
import { Toast } from 'src/shared/components/toast';
export function PublishSwitch() {
    const { t } = useTranslation();
    const { moduleId, pageId } = useParams();
    const moduleRequest = useGetModuleById(moduleId);
    const { watch, setValue, getValues } = useFormContext();
    const publishContentMutation = usePublishContentMutation();
    function handlePublish(event) {
        if (!pageId)
            return;
        const enabled = event.currentTarget.checked;
        setValue('published', enabled);
        const payload = {
            modules: null,
            published: enabled,
            notifyEmail: false,
            pages: [pageId]
        };
        publishContentMutation.mutate(payload, {
            onSuccess: () => {
                Toast.show({
                    type: 'success',
                    message: enabled
                        ? t('content.toast.edit.publish.success')
                        : t('content.toast.edit.unpublish.success')
                });
                window.dispatchEvent(new CustomEvent('app-content-admin:content:saved', {
                    detail: {
                        moduleId,
                        isUpdating: true,
                        isExtraModule: Boolean(moduleRequest.data?.extra)
                    }
                }));
            },
            onError: () => {
                Toast.show({
                    type: 'danger',
                    message: enabled
                        ? t('content.toast.edit.publish.error')
                        : t('content.toast.edit.unpublish.error')
                });
            },
            onSettled: (data, error) => {
                const formValues = getValues();
                const statusCode = error instanceof ApiError ? error?.statusCode : data?.request.status;
                DataHubService.sendEvent({
                    schema: new TryPagePublishSchema({
                        statusCode,
                        pageId: pageId,
                        createNextEnable: false,
                        result: error ? 'FAILURE' : 'SUCCESSFUL',
                        hasTag: Boolean(formValues.tags?.length),
                        hasText: Boolean(formValues.content),
                        hasMedia: Boolean(formValues.medias?.length),
                        componentName: 'CONTENT_EDIT_PUBLISH_BUTTON',
                        actionType: enabled ? 'PUBLISH' : 'UNPUBLISH',
                        hasFile: Boolean(formValues.attachments?.length),
                        hasDripping: Boolean(formValues.drippings?.length),
                        hasUrl: Boolean(formValues.complementaryReadings?.length),
                        failureDescription: error?.message ?? 'NOT_FAILURE_RESULT_EVENT'
                    })
                });
            }
        });
        if (!moduleId)
            return;
        PageCacheUpdater.updatePublishStatus(moduleId, pageId, enabled);
    }
    return (_jsx("div", { className: "flex w-full justify-center rounded-large border-radius border-small border-neutral-200 px-3 py-2 md:w-auto", children: _jsx(Switch, { className: "!mb-0", id: "publish-content", onChange: handlePublish, checked: watch('published'), label: watch('published') ? t('content.published') : t('content.publish') }) }));
}
